import * as R from 'ramda'

export const transformAudienceRuleToUiState = (audienceRules, customerFields) =>
  audienceRules.audience_rules.map((rule) =>
    R.compose(
      R.assoc('operator', rule.operator),
      R.prop('audience_rule'),
      R.over(R.lensProp('audience_rule'), (audienceRule) =>
        mapAudienceRuleLabel(audienceRule, customerFields)
      )
    )(rule)
  )

const mapAudienceRuleLabel = (audienceRule, customerFields) => {
  return R.compose(
    R.pick(['condition', 'field', 'value', 'id']),
    R.over(R.lensProp('field'), (field) => {
      const matchedField = findMatchedField(field, customerFields)
      return {
        label: matchedField.label || field,
        value: matchedField.field || field,
        key: matchedField.key,
        isCoreField: matchedField.isCoreField,
        field_type: matchedField.field_type,
      }
    })
  )(audienceRule)
}

export const findMatchedField = (audienceRulesField, advanceFilterList) => {
  if (audienceRulesField.includes('ticket.custom_attributes')) {
    const field = audienceRulesField.split('ticket.custom_attributes.')[1]
    const matchedField = advanceFilterList.find((option) => {
      if (option.field == field && option.key == 'ticket.attribute') {
        return true
      } else {
        return false
      }
    })
    return matchedField
  } else {
    const matchedField = R.find(R.propEq('field', audienceRulesField), advanceFilterList) || {}
    return matchedField
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/domains/email/index.js